import {
  AnonimousProfile,
  FacebookUserProfile,
  SocialNetwork,
  UserProfile,
  UserAccount,
} from "../types/Game";
import LocalFOrage from "./Localforage";
import GameApi from "./GameApi";
import { StatusCodes } from "http-status-codes";
import { v4 as uuidv4 } from "uuid";
import Firebase from "./Firebase";
import { EXPIRY_TIME_IN_SECONDS } from "../config/Constants";

const USER_SESSION = "USER_SESSION";

const getProfileUrl = (socialNetworkId: string) => {
  return `https://graph.facebook.com/${socialNetworkId}/picture?type=large`;
};

const startSessionWithFacebook = async (
  user: FacebookUserProfile
): Promise<UserAccount> => {
  const data: UserProfile = {
    socialNetworkId: user.id,
    socialNetwork: SocialNetwork.Facebook,
    name: user.name,
    profileUrl: getProfileUrl(user.id),
  };

  const userInfo = await logInUserInApi(data);
  LocalFOrage.saveItemWithExpiry(
    USER_SESSION,
    { ...userInfo, socialNetwork: SocialNetwork.Facebook },
    EXPIRY_TIME_IN_SECONDS
  );
  return userInfo;
};

const startAnonimousSession = async (user: AnonimousProfile) => {
  const profile: UserProfile = {
    socialNetworkId: uuidv4(),
    socialNetwork: SocialNetwork.Anonymous,
    name: user.name,
    profileUrl: user.profileUrl,
  };

  const userInfo = await logInUserInApi(profile);

  return LocalFOrage.saveItemWithExpiry(
    USER_SESSION,
    { ...userInfo, socialNetwork: SocialNetwork.Anonymous },
    EXPIRY_TIME_IN_SECONDS
  );
};

const endSession = async () => {
  await Firebase.logoutUser();
  return LocalFOrage.removeItem(USER_SESSION);
};

const getSession = async (): Promise<UserAccount | null> => {
  return LocalFOrage.getItemWithExpiry<UserAccount>(USER_SESSION);
};

const getUser = async (): Promise<UserAccount | null> => {
  return getSession();
};

const getUserImage = async (): Promise<string> => {
  const user = await getSession();
  return user ? user.profileUrl : "";
};

const isUserLoggedIn = async () => {
  const user = await getSession();
  return user?.userId ? true : false;
};

const isAnonimous = async () => {
  const user = await getSession();
  return user?.socialNetwork === SocialNetwork.Anonymous;
};

const logInUserInApi = async (user: UserProfile) => {
  const loginRes = await GameApi.login(
    SocialNetwork.Facebook,
    user.socialNetworkId
  );
  if (loginRes.status === StatusCodes.OK) {
    return loginRes.data;
  }
  return createUserInApi(user);
};

const createUserInApi = async (user: UserProfile) => {
  const { data } = await GameApi.createProfile(user);
  return data;
};

export default {
  startSessionWithFacebook,
  endSession,
  isUserLoggedIn,
  getSession,
  startAnonimousSession,
  getUserImage,
  getUser,
  isAnonimous,
};
